import { useDispatch } from 'react-redux'
import { twMerge } from 'tailwind-merge'
import { managementActions, managementSelectors, useManagement } from '../../../../store'

function DeviceSwitcher() {
  const isDesktop = useManagement(managementSelectors.isDesktop)
  const dispatch = useDispatch()

  return (
    <div className="flex items-center">
      <button
        className={twMerge(
          isDesktop ? 'text-brand-primary' : 'text-fill-primary',
          'main-transition-colors hover:text-brand-primary p-3.5',
        )}
        onClick={() => dispatch(managementActions.setIsDesktop(true))}
      >
        <i className="fas fa-desktop" />
      </button>
      <button
        className={twMerge(
          !isDesktop ? 'text-brand-primary' : 'text-fill-primary',
          'main-transition-colors hover:text-brand-primary p-3.5',
        )}
        onClick={() => dispatch(managementActions.setIsDesktop(false))}
      >
        <i className="fas fa-mobile-alt" />
      </button>
    </div>
  )
}

export default DeviceSwitcher
